// src/redux/middleware/bindingMiddleware.ts

import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { Row } from '../types';
import {
    addRow,
    addRows,
    clearRows,
    initializeRows,
    removeRow,
    setRows,
    updateCell,
    updateRow,
} from '../row/slice';
import { makeSelectRowById } from '../selectors';
import RootState from '../../../../../app/appStore';

import listenerRegistry from './listenerRegistry';

const bindingMiddleware = createListenerMiddleware();

bindingMiddleware.startListening({
    matcher: isAnyOf(
        initializeRows,
        addRow,
        addRows,
        setRows,
        updateRow,
        removeRow,
        clearRows,
        updateCell
    ),
    effect: async (action, listenerApi) => {
        const payload = action.payload as any;
        const tableId: string = payload.tableId;

        // Handle single row addition action
        if (addRow.match(action)) {
            const row: Row = payload.row;
            const listeners = listenerRegistry.getRowAddListeners(tableId);

            listeners.forEach((listener) => {
                try {
                    listener(tableId, row);
                } catch (error) {
                    console.error('Error in row add listener (single row):', error);
                }
            });
        }

        // Handle multiple rows addition action
        if (addRows.match(action)) {
            const rows: Row[] = payload.rows;
            const listeners = listenerRegistry.getRowsAddListeners(tableId);

            listeners.forEach((listener) => {
                try {
                    listener(tableId, rows);
                } catch (error) {
                    console.error('Error in row add listener (multiple rows):', error);
                }
            });
        }

        // Handle row update actions
        if (updateRow.match(action)) {
            const rows: Row[] = Array.isArray(payload.rows) ? payload.rows : [payload.row];
            const listeners = listenerRegistry.getRowUpdateListeners(tableId);

            listeners.forEach((listener) => {
                try {
                    listener(tableId, rows);
                } catch (error) {
                    console.error('Error in row update listener:', error);
                }
            });
        }

        // Handle cell update actions
        if (updateCell.match(action)) {
            const { tableId, rowId, columnId, cell } = payload;
            const targetRow = makeSelectRowById(tableId, rowId)(RootState.getState());
            
            if (targetRow) {
                const listeners = listenerRegistry.getCellUpdateListeners(tableId);
                for (const listener of listeners) {
                    try {
                        listener(tableId, { ...cell, rowId: rowId, columnId: columnId });
                    } catch (error) {
                        console.error('Error in cell update listener:', error);
                    }
                }
            }
        }

    },
});

export default bindingMiddleware;
